export const url = (value) => {
  const pattern = new RegExp(/^(http|https):\/\/[^ "]+$/);
  return pattern.test(value);
}
